import axios from 'axios';
import { CashFlowForecastResponse } from '../types/cashFlow';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

export const cashFlowService = {
  getForecast: async (horizonWeeks: number = 12): Promise<CashFlowForecastResponse> => {
    const response = await axios.get(`${API_URL}/cash-flow/forecast`, {
      params: { horizon_weeks: horizonWeeks },
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};
